import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { VariantTreeLevel } from './components/VariantTreeLevel/VariantTreeLevel.js';

const VariantSelectorTree = ({ className  })=>{
    const { product: { variantFacetTree: unfilteredVariantFacetTree1  } , activeVariant: { sku: activeSku  } ,  } = useProductData();
    if (!unfilteredVariantFacetTree1.length) return null;
    const renderTreeLevel = (unfilteredVariantFacetTree)=>{
        const variantFacetTree = unfilteredVariantFacetTree.filter((treeNode)=>treeNode.facetTerm !== null
        );
        const nullVariantFacetTree = unfilteredVariantFacetTree.filter((treeNode)=>treeNode.facetTerm === null
        );
        const nullRootNode = nullVariantFacetTree[0];
        const skipTreeLevel = unfilteredVariantFacetTree.length === nullVariantFacetTree.length && nullRootNode;
        const skipNodeInLevel = unfilteredVariantFacetTree.length > nullVariantFacetTree.length && nullVariantFacetTree.length !== 0;
        if (skipNodeInLevel) {
            nullVariantFacetTree.forEach((nullNode)=>console.warn(`Variant with sku "${nullNode.sku}" has a misconfigured facet for property "${nullNode.facetKey}". This variant branch has been removed from the variant selector tree.`)
            );
        }
        let childBranch;
        let treeLevel = null;
        if (skipTreeLevel) {
            childBranch = nullRootNode.childFacets;
        } else {
            const activeNode = variantFacetTree.find((node)=>node.skuCollection.includes(activeSku)
            ) || variantFacetTree[0];
            childBranch = (activeNode === null || activeNode === void 0 ? void 0 : activeNode.childFacets) || [];
            treeLevel = /*#__PURE__*/ React.createElement(VariantTreeLevel, {
                treeLevelVariants: variantFacetTree,
                activeNode: activeNode
            });
        }
        if (childBranch.length > 0) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, treeLevel, renderTreeLevel(childBranch));
        } else {
            return treeLevel;
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "variant-selector-tree",
        className: className
    }, renderTreeLevel(unfilteredVariantFacetTree1));
};

export { VariantSelectorTree };
//# sourceMappingURL=VariantSelectorTree.js.map
